import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../utils/apiInstance";

export const fetchRestaurants = createAsyncThunk('restaurants/fetchRestaurants', async (_, { rejectWithValue }) => {
    try {
        const response = await apiInstance.get('/restaurantList');
        return response.data.restaurantList;
    } catch (error) {
        return rejectWithValue(error.response.data?.message || "An error occurred while fetching restaurant's list...");
    }
});

export const deleteRestaurant = createAsyncThunk('restaurants/deleteRestaurant', async (id, { rejectWithValue }) => {
    try {
        await apiInstance.delete(`/deleteRestaurant/${id}`);
        return id;
    } catch (error) {
        return rejectWithValue(error.response.data?.message || "An error occurred while deleting restaurant..");
    }
});

export const toggleRestaurantStatus = createAsyncThunk('restaurants/toggleRestaurantStatus', async ({ id, status }, { rejectWithValue }) => {
    try {
        await apiInstance.put(`/updateStatus/${id}`, { status });
        return { id, status };
    } catch (error) {
        return rejectWithValue(error.response.data?.message || "An error occurred while updating restaurant's status..");
    }
});

const restaurantSlice = createSlice({
    name: 'restaurants',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRestaurants.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchRestaurants.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchRestaurants.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteRestaurant.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteRestaurant.fulfilled, (state, action) => {
                state.loading = false;
                state.data = state.data.filter((restaurant) => restaurant.id !== action.payload);
            })
            .addCase(toggleRestaurantStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(toggleRestaurantStatus.fulfilled, (state, action) => {
                state.loading = false;
                const { id, status } = action.payload;
                const restaurant = state.data.find((restaurant) => restaurant.id === id);
                if (restaurant) {
                    restaurant.status = status;
                }
            });
    }
});

export default restaurantSlice.reducer;